export { default } from './DashboardPinnedComments';
